<template>

    <LoopItemPanel title="Item">

        <div class="canvas-blocks-custom-2column-admin-LoopItemPanel">



        </div>

    </LoopItemPanel>

</template>

<script>

import LoopItemPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/loop/owlCarousel/LoopItemPanel";

export default {

    extends: LoopItemPanel,

    components: {
        LoopItemPanel,
    },

    data() {
        return {};
    },

}
</script>
